import { render, staticRenderFns } from "./securitygroup_tenantrules.vue?vue&type=template&id=2b85716e&"
import script from "./securitygroup_tenantrules.vue?vue&type=script&lang=js&"
export * from "./securitygroup_tenantrules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports